import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFiles(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2C7.89543 2 7 2.89543 7 4V5H5C3.89543 5 3 5.89543 3 7V20C3 21.1046 3.89543 22 5 22H15C16.1046 22 17 21.1046 17 20V18H18C19.1046 18 20 17.1046 20 16V7.58579L14.4142 2H9ZM18 16V9H14C13.4477 9 13 8.55228 13 8V4H9V16H18ZM15 18V20H5V7H7V16C7 17.1046 7.89543 18 9 18H15Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
